import { useAppSelector } from '@/redux/store';
import { OrganizationUserRoleSlugs } from '@/types/users';

/**
 * Hook to check if the logged in user is a hub user
 *
 * @returns {boolean} - Whether the logged user is a hub user or not
 */
export function useIsHubUser(): boolean {
  const loggedUser = useAppSelector(state => state.loggedUser);

  return (
    (
      loggedUser?.organizationUserRoles?.filter(
        role => role.slug === OrganizationUserRoleSlugs.HUB_USER
      ) || []
    ).length > 0
  );
}

export default useIsHubUser;
